module.exports = __webpack_public_path__ + "static/logo-58ada3a86b106eb883abfb13e29cdea5.svg";